import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchCurrentUser} from "../../../creators/currentUser";
import {fetchUsersIgnored, resetUsersIgnored} from "../../../creators/user.usersIgnored";
import {deleteUserIgnored} from "../../../creators/user.userIgnored";

import IgnoreUser from './IgnoreUser';
import {PageLoader} from '../Loader';

class IgnoreUserList extends React.Component {
    constructor(props) {
        super(props);

        this.handleRemoveIgnoredUser = this.handleRemoveIgnoredUser.bind(this);

        this.props.fetchCurrentUser();
        this.props.fetchUsersIgnored({limit : false});
    }

    /*componentDidUpdate(prevProps) {
        if (prevProps.userIgnored.update !== this.props.userIgnored.update) {
            this.props.resetUsersIgnored();
            this.props.fetchUsersIgnored();
        }
    }*/

    componentWillUnmount() {
        this.props.resetUsersIgnored();
    }

    handleRemoveIgnoredUser(userId) {
        this.props.deleteUserIgnored(userId).then(response=>{
            this.props.resetUsersIgnored();
            this.props.fetchUsersIgnored();
        }).catch(e=>{

        });
    }

    render() {
        return !this.props.userBannedUsersInitialized ? <PageLoader/> : (
            <div className="content blocked">
                <label className="label-title">Utilisateurs que je bloque</label>
                {!this.props.userBannedUsersLoading && this.props.userBannedUsersTotal === 0 && (
                    <div className="no-content">Aucun utilisateur bloqué</div>
                )}
                <div className="ignored-user-wrapper">
                    <div className="wrapper-profil-ignored-user">
                        <div className="main-wrapper">
                            {this.props.userBannedUsersLoading ? (
                                <PageLoader/>
                            ) : (
                                <div className="list">
                                    {this.props.userBannedUsers.map((item) => (
                                        <IgnoreUser key={item._id} {...item}
                                                    userIgnoredLoading={this.props.userIgnoredLoading}
                                                    handleRemoveIgnoredUser={this.handleRemoveIgnoredUser}/>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userBannedUsers: state.usersIgnored.data,
        userBannedUsersLoading: state.usersIgnored.loading,
        userBannedUsersInitialized: state.usersIgnored.initialized,
        userBannedUsersTotal: state.usersIgnored.total,

        userIgnored: state.userIgnored.data,
        userIgnoredLoading: state.userIgnored.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,

    fetchUsersIgnored,
    resetUsersIgnored,

    deleteUserIgnored,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(IgnoreUserList);
